module.exports = __webpack_public_path__ + "img/FERMER_FILTRE_OU_RECHERCHE.870c5618.svg";